var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMjPointLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130.96 32.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4f60ab;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.96.26h3.51l2.31,6.32c.28.84.53,1.75.82,2.63h.09c.28-.88.53-1.79.81-2.63l2.24-6.32h3.51v14.22h-2.93v-5.22c0-1.39.26-3.46.41-4.83h-.09l-1.17,3.37-2.01,5.45h-1.78l-2.01-5.45-1.13-3.37h-.09c.15,1.38.41,3.44.41,4.83v5.22h-2.88V.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.25,12.17l2.19-1.63c.53.98,1.25,1.42,1.98,1.42,1.15,0,1.77-.59,1.77-2.48V.26h3.22v9.49c0,2.74-1.42,4.99-4.56,4.99-2.17,0-3.6-.85-4.59-2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.05.26h4.88c3.13,0,5.65,1.12,5.65,4.57s-2.55,4.82-5.57,4.82h-1.76v4.82h-3.21V.26ZM76.83,7.1c1.77,0,2.6-.79,2.6-2.27s-.95-2.02-2.69-2.02h-1.48v4.29h1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.38,7.31c0-4.65,2.62-7.31,6.46-7.31s6.46,2.68,6.46,7.31-2.62,7.43-6.46,7.43-6.46-2.79-6.46-7.43ZM94,7.31c0-2.85-1.22-4.53-3.16-4.53s-3.16,1.68-3.16,4.53,1.22,4.66,3.16,4.66,3.16-1.81,3.16-4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.97.26h3.21v14.22h-3.21V.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.54.26h3.29l3.71,7.07,1.41,3.12h.09c-.15-1.5-.41-3.5-.41-5.17V.26h3.06v14.22h-3.29l-3.71-7.09-1.41-3.11h-.09c.15,1.57.41,3.47.41,5.15v5.05h-3.06V.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123.83,2.96h-3.91V.26h11.04v2.7h-3.91v11.52h-3.22V2.96Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.22,22.2h-2.57v-1.33h6.73v1.33h-2.57v7.59h-1.58v-7.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.86,20.87h5.37v1.33h-3.78v2.29h3.21v1.33h-3.21v2.64h3.92v1.33h-5.5v-8.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.73,25.36c0-2.92,1.83-4.65,4.08-4.65,1.12,0,2.01.53,2.57,1.13l-.85,1.02c-.46-.46-.99-.77-1.69-.77-1.45,0-2.49,1.23-2.49,3.23s.96,3.27,2.45,3.27c.79,0,1.4-.37,1.9-.92l.85.99c-.72.84-1.65,1.3-2.81,1.3-2.24,0-4.02-1.64-4.02-4.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.05,20.87h1.58v3.58h3.6v-3.58h1.58v8.92h-1.58v-3.95h-3.6v3.95h-1.58v-8.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.09,20.87h1.63l2.77,5.01.92,1.9h.06c-.08-.92-.2-2.05-.2-3.04v-3.87h1.51v8.92h-1.63l-2.77-5.02-.92-1.9h-.05c.08.94.2,2.02.2,3.01v3.9h-1.51v-8.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.56,25.29c0-2.88,1.61-4.59,3.93-4.59s3.93,1.71,3.93,4.59-1.61,4.66-3.93,4.66-3.93-1.77-3.93-4.66ZM85.8,25.29c0-2-.9-3.21-2.31-3.21s-2.31,1.21-2.31,3.21.9,3.28,2.31,3.28,2.31-1.28,2.31-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.22,20.87h1.58v7.59h3.7v1.33h-5.28v-8.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.6,25.29c0-2.88,1.61-4.59,3.93-4.59s3.93,1.71,3.93,4.59-1.61,4.66-3.93,4.66-3.93-1.77-3.93-4.66ZM101.84,25.29c0-2-.91-3.21-2.31-3.21s-2.31,1.21-2.31,3.21.91,3.28,2.31,3.28,2.31-1.28,2.31-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.79,25.36c0-2.92,1.85-4.65,4.22-4.65,1.26,0,2.13.56,2.69,1.13l-.85,1.02c-.45-.44-.97-.77-1.8-.77-1.58,0-2.64,1.23-2.64,3.23s.94,3.27,2.73,3.27c.5,0,.99-.14,1.27-.39v-1.93h-1.68v-1.3h3.1v3.93c-.59.6-1.62,1.06-2.85,1.06-2.4,0-4.2-1.64-4.2-4.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.82,20.87h1.58v8.92h-1.58v-8.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117.66,20.87h5.37v1.33h-3.78v2.29h3.21v1.33h-3.21v2.64h3.92v1.33h-5.5v-8.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.39,28.65l.92-1.09c.64.61,1.49,1.02,2.32,1.02,1,0,1.55-.46,1.55-1.15,0-.73-.58-.97-1.38-1.31l-1.22-.53c-.88-.37-1.8-1.06-1.8-2.36,0-1.42,1.25-2.51,2.99-2.51,1.04,0,2.05.43,2.75,1.14l-.81,1c-.57-.48-1.17-.77-1.94-.77-.85,0-1.4.4-1.4,1.05,0,.7.68.96,1.42,1.26l1.2.5c1.06.44,1.8,1.11,1.8,2.41,0,1.45-1.2,2.65-3.2,2.65-1.2,0-2.37-.47-3.21-1.31Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.96,
    y: 0.36,
    width: 10.48,
    height: 10.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.48,
    y: 10.84,
    width: 10.48,
    height: 10.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 21.32,
    width: 10.48,
    height: 10.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.32,18.02v10.1h-5.87v3.99h6.89c1.64,0,2.98-1.33,2.98-2.98v-11.11h-3.99Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMjPointLogoWhite);
export default __webpack_public_path__ + "static/media/mj_point_logo_white.134ed8d2c77154abe8cbb632b88d692f.svg";
export { ForwardRef as ReactComponent };